function checkLeadDimensionRowFit(row) {
  const collectionName = row.querySelector(".lsa-rebuy-collection-name")
  const leadDimension = row.querySelector(".lsa-rebuy-lead-dimension")
  if (!collectionName || !leadDimension) return

  leadDimension.style.display = ""

  const gap =
    parseFloat(getComputedStyle(row).columnGap || getComputedStyle(row).gap) ||
    0
  const rowWidth = row.clientWidth
  const nameWidth = collectionName.scrollWidth

  const measurer = document.createElement("span")
  measurer.className = leadDimension.className
  measurer.textContent = leadDimension.textContent
  measurer.setAttribute("aria-hidden", "true")
  measurer.style.cssText =
    "position:absolute;visibility:hidden;white-space:nowrap;pointer-events:none;"
  row.appendChild(measurer)
  const leadWidth = measurer.offsetWidth
  row.removeChild(measurer)

  if (nameWidth + gap + leadWidth > rowWidth) {
    leadDimension.style.display = "none"
  }
}

function checkRebuyLeadDimensionRows(widgetEl) {
  if (!widgetEl) return
  widgetEl
    .querySelectorAll(".lsa-rebuy-collection-row")
    .forEach(checkLeadDimensionRowFit)
}

let leadDimensionResizeTimeout

function initRebuyLeadDimensionResize() {
  if (initRebuyLeadDimensionResize._bound) return
  initRebuyLeadDimensionResize._bound = true

  window.addEventListener("resize", () => {
    clearTimeout(leadDimensionResizeTimeout)
    leadDimensionResizeTimeout = setTimeout(() => {
      document
        .querySelectorAll(".lsa-rebuy-collection-row")
        .forEach(checkLeadDimensionRowFit)
    }, 150)
  })
}

function scheduleRebuyLeadDimensionChecks(widgetEl) {
  if (!widgetEl) return
  ;[100, 400, 1000].forEach((delay) => {
    setTimeout(() => checkRebuyLeadDimensionRows(widgetEl), delay)
  })
}

function hookUpRebuySliderControls(widget) {
  const view = widget?.View
  if (!view) return

  const widgetEl = document.querySelector(`#rebuy-widget-${widget.id}`)
  scheduleRebuyLeadDimensionChecks(widgetEl)

  function bind() {
    const splide = view.carousel
    if (!splide) return false

    if (!widgetEl) return false

    const paginationEl = widgetEl.querySelector('.rebuy-upsell-splide-pagination')
    const arrowNext = widgetEl.querySelector('.rebuy-upsell-splide-arrow-next')
    const paginationContainer = widgetEl.querySelector('.rebuy-upsell-splide-pagination-container')

    if (!paginationEl || !arrowNext) return false
    if (arrowNext._rbInit) return true

    arrowNext._rbInit = true

    const updatePagination = () => {
      const perPage = splide.options?.perPage || 1
      const totalSlides = splide.Components?.Slides?.getLength(true) || 0
      if (!totalSlides) return

      const totalPages = Math.ceil(totalSlides / perPage)
      const currentPage = Math.floor(splide.index / perPage) + 1

      paginationEl.textContent = `${currentPage} / ${totalPages}`

      if (paginationContainer) {
        paginationContainer.style.visibility = totalPages > 1 ? 'visible' : 'hidden'
      }
    }   

    splide.on('mounted move', () => {
      updatePagination()
      checkRebuyLeadDimensionRows(widgetEl)
    })

    document.addEventListener('rebuy.add', () => setTimeout( () => updatePagination(), 1300))
    document.addEventListener('rebuy:cart.change', () => setTimeout( () => updatePagination(), 1300))


    setTimeout(() => {
      updatePagination()
      checkRebuyLeadDimensionRows(widgetEl)
    }, 100)

    arrowNext.addEventListener('click', () => splide.go('>'))

    return true
  }

  if (!bind()) {
    const interval = setInterval(() => {
      if (bind()) clearInterval(interval)
    }, 50)
    setTimeout(() => clearInterval(interval), 8000)
  }
}

function initRebuyCartSync() {
  const dispatch = () => document.dispatchEvent(new CustomEvent('lsa:cart:updated'))
  document.addEventListener('rebuy:cart.add', dispatch)
  document.addEventListener('rebuy:cart.change', dispatch)
}

export default function initRebuyUpsellControls() {
  initRebuyLeadDimensionResize()

  const pending = window._rebuyPendingWidgets || []
  pending.forEach(hookUpRebuySliderControls)

  if (window.Rebuy?.widgets?.length) {
    window.Rebuy.widgets.forEach(hookUpRebuySliderControls)
  }

  document.addEventListener('rebuy.ready', (event) => {
    hookUpRebuySliderControls(event.detail?.widget)
  })

  initRebuyCartSync()
}
